import { injectTranslate } from '@core/i18n-legacy';
import { cellTransformFullDate, textCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const publishedAtColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.PublishedAt,
  label: injectTranslate()('app.offers.table.publish_date'),
  visible: false,
  geometry: {
    width: 130,
    minWidth: 130,
    maxWidth: 190,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('publishedAt', cellTransformFullDate),
}));
